import { ScoreHealthRangeBreakpoint } from '../../..';

export const INSURANCE_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS: ScoreHealthRangeBreakpoint[] = [
  { category: 'atypicallyLow', min: 0, max: 0.2, id: 'atypicallyLow_Ir' },
  { category: 'low', min: 0.2, max: 0.4, id: 'low_Ir' },
  { category: 'typical', min: 0.4, max: 0.8, id: 'typical_Ir' },
  { category: 'high', min: 0.8, max: 0.9, id: 'high_Ir' },
  { category: 'atypicallyHigh', min: 0.9, max: 1, id: 'atypicallyHigh_Ir' },
];
